import { Box, Typography } from '@mui/material';
import ProgressBar from '@/components/common/ProgressBar';

const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    width: '100%',
    mt: 0.5,
    maxWidth: { xs: '100%', xl: '600px' },
} as const;

interface NumericAnswerProps {
    answer: number | string;
    maxScore: number;
}

const NumericAnswer: React.FC<NumericAnswerProps> = ({ answer, maxScore }) => {
    const numericValue = typeof answer === 'string' ? parseInt(answer, 10) : Number(answer);
    const answerScore = Math.min(numericValue, maxScore);
    const percentage = (answerScore / maxScore) * 100;

    return (
        <Box sx={containerStyles}>
            <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                <ProgressBar value={percentage} />
            </Box>
            <Typography component="div" variant="body2" sx={{ minWidth: '60px' }}>
                {`${answerScore}/${maxScore}`}
            </Typography>
        </Box>
    );
};

export default NumericAnswer;
